import axios from 'axios';

const axiosSRP = axios.create();

axiosSRP.interceptors.request.use(
  (config) => {
    const userData = localStorage.getItem('userDetails');
    const accessToken = localStorage.getItem('accessToken');
    const authType = localStorage.getItem('authType');

    if (userData && JSON.parse(userData)?.user_id) {
      config.headers.RequestorUserID = JSON.parse(userData)?.user_id;
    } else {
      config.headers.RequestorUserID = undefined;
    }

    config.headers.Authorization = `Bearer ${accessToken}`;
    config.headers.AuthType = authType;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// If the server is in a migration-failure brownout it returns 503 with
// { status: 'maintenance' }. An already-open SPA would otherwise just show
// broken UI, so signal a full-screen maintenance overlay (MaintenanceOverlay
// listens for this event). The error still rejects so callers behave normally.
axiosSRP.interceptors.response.use(
  (response) => response,
  (error) => {
    const res = error && error.response;
    if (res && res.status === 503 && res.data && res.data.status === 'maintenance') {
      window.dispatchEvent(new Event('srp-maintenance'));
    }
    return Promise.reject(error);
  }
);

export default axiosSRP;